import angular from 'angular';
import jsData from 'js-data-angular';
import {Dijagnoza} from './dijagnoza.js';
import {Djelatnik} from './djelatnik.js';
import {Grad} from './grad.js';
import {Nalaz} from './nalaz.js';
import {Pacijent} from './pacijent.js';
import {Pregled} from './pregled.js';
import {DjelatnostPoliklinike} from './djelatnost.js';
import {VrstaPosjete} from './vrstaPosjete.js';
import {Uputnica} from './uputnica.js';
import {Pristanak} from './pristanak.js';

const models = angular.module('models', [jsData]);

Config.$inject = ['DSProvider', 'DSHttpAdapterProvider', '$httpProvider'];
function Config(DSProvider, DSHttpAdapterProvider, $httpProvider) {
    angular.extend(DSProvider.defaults, {
        bypassCache: true,
        cacheResponse: false,
        deserialize: function(resourceName, res) {
            if (angular.isDefined(res.data) &&
                angular.isDefined(res.data.results)) {
                var newResponse = res.data.results;
                newResponse.meta = {
                    'count': res.data.count,
                    'next': res.data.next,
                    'previous': res.data.previous,
                    'start': res.data.start,
                    'end': res.data.end
                };
                return newResponse;
            }
            return res.data;
        },
    });
    angular.extend(DSHttpAdapterProvider.defaults, {
        basePath: '/api/ordinacija',
    });

    $httpProvider.defaults.xsrfCookieName = 'csrftoken';
    $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
}

models.config(Config);

models.factory('Dijagnoza', Dijagnoza);
models.factory('Djelatnik', Djelatnik);
models.factory('Grad', Grad);
models.factory('Nalaz', Nalaz);
models.factory('Pacijent', Pacijent);
models.factory('Pregled', Pregled);
models.factory('DjelatnostPoliklinike', DjelatnostPoliklinike);
models.factory('VrstaPosjete', VrstaPosjete);
models.factory('Uputnica', Uputnica);
models.factory('Pristanak', Pristanak);

export {models};



// WEBPACK FOOTER //
// ./app/models/models.js